(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCoverHoverGalleries(root) {
    var galleries = (root || document).querySelectorAll('.cover-hover-gallery:not([data-hover-init])');
    galleries.forEach(function (gallery) {
      gallery.setAttribute('data-hover-init', 'true');
      var others = gallery.querySelectorAll('.cover-hover-gallery__img:not(.cover-hover-gallery__img--base)');
      if (others.length === 0) return;

      var index = 0;
      var interval = null;

      gallery.addEventListener('mouseenter', function () {
        gallery.classList.add('is-hovering');
        others[0].classList.add('is-active');
        index = 0;
        interval = setInterval(function () {
          others[index].classList.remove('is-active');
          index = (index + 1) % others.length;
          others[index].classList.add('is-active');
        }, 900);
      });

      gallery.addEventListener('mouseleave', function () {
        clearInterval(interval);
        gallery.classList.remove('is-hovering');
        others.forEach(function (img) {
          img.classList.remove('is-active');
        });
        index = 0;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCoverHoverGalleries(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCoverHoverGalleries(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  function initCoverHoverGalleries(root) {
    var galleries = (root || document).querySelectorAll('.cover-hover-gallery:not([data-hover-init])');
    galleries.forEach(function (gallery) {
      gallery.setAttribute('data-hover-init', 'true');
      var others = gallery.querySelectorAll('.cover-hover-gallery__img:not(.cover-hover-gallery__img--base)');
      if (others.length === 0) return;

      var index = 0;
      var interval = null;

      gallery.addEventListener('mouseenter', function () {
        gallery.classList.add('is-hovering');
        others[0].classList.add('is-active');
        index = 0;
        interval = setInterval(function () {
          others[index].classList.remove('is-active');
          index = (index + 1) % others.length;
          others[index].classList.add('is-active');
        }, 900);
      });

      gallery.addEventListener('mouseleave', function () {
        clearInterval(interval);
        gallery.classList.remove('is-hovering');
        others.forEach(function (img) {
          img.classList.remove('is-active');
        });
        index = 0;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCoverHoverGalleries(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCoverHoverGalleries(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-column"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCoverHoverGalleries(root) {
    var galleries = (root || document).querySelectorAll('.cover-hover-gallery:not([data-hover-init])');
    galleries.forEach(function (gallery) {
      gallery.setAttribute('data-hover-init', 'true');
      var others = gallery.querySelectorAll('.cover-hover-gallery__img:not(.cover-hover-gallery__img--base)');
      if (others.length === 0) return;

      var index = 0;
      var interval = null;

      gallery.addEventListener('mouseenter', function () {
        gallery.classList.add('is-hovering');
        others[0].classList.add('is-active');
        index = 0;
        interval = setInterval(function () {
          others[index].classList.remove('is-active');
          index = (index + 1) % others.length;
          others[index].classList.add('is-active');
        }, 900);
      });

      gallery.addEventListener('mouseleave', function () {
        clearInterval(interval);
        gallery.classList.remove('is-hovering');
        others.forEach(function (img) {
          img.classList.remove('is-active');
        });
        index = 0;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCoverHoverGalleries(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initCoverHoverGalleries(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
